import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PATH } from 'shared/constant';

export default class FakeIndex extends Component {
  render() {
    return (
      <Redirect to={PATH.LOGIN} />
    );
  }
}
